module.exports = "<span class=\"field-value\"\n      matTooltip=\"Editar este campo\"\n      tabindex=\"0\" [class.invalid]=\"invalid && !pristine\" contenteditable\n      [innerHTML]=\"control.value\"\n      #editableField (focus)=\"onFocus()\" (focusout)=\"onFocusOut()\"\n      (paste)=\"onPaste($event)\"\n      (keyup)=\"checkValueAfterEmpty()\"\n      [class.empty]=\"control.value.length === 0 && empty\"\n>\n</span>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/forms/components/form-data-fillable-text-field/fillable-text-field.component.html
// module id = ./src/app/forms/components/form-data-fillable-text-field/fillable-text-field.component.html
// module chunks = main